import CalendarSlotPicker from "./CalendarSlotPicker.jsx";

/**
 * @param {object} props
 * @param {function(Date, Date, string=): void} props.onSlotSelect - Aangeroepen zodra
 *   er een tijdslot gekozen is; het derde argument is de medewerker op wiens
 *   regel geklikt is in de roosterweergave, of undefined
 * @param {boolean} [props.fixtool] - Of de organisatie FIXtool heeft (`householdPlanningEnabled`)
 * @param {*} [props.scheduleSetting] - `CompagnyMeta.AgendaScheduleDisplay`, ruw uit useSettings
 */
const AddTaskModalContent = ({ onSlotSelect, fixtool, scheduleSetting }) => (
  <>
    <p className="add-task-modal-content-error">
      Klik op een tijdslot in de kalender om de afspraak in te plannen. In de
      weergave 'rooster' kies je meteen de medewerker: klik op een tijdslot op
      zijn regel.
    </p>
    <CalendarSlotPicker onSelect={onSlotSelect} fixtool={fixtool} scheduleSetting={scheduleSetting} />
  </>
);

export default AddTaskModalContent;
